module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "height40 common"
  }, [_c('el-popover', {
    ref: "messageBox",
    attrs: {
      "placement": "bottom",
      "width": "350",
      "trigger": "click",
      "disabled": !_vm.unreadMessageInfo.totalCount
    },
    model: {
      value: (_vm.messageVisible),
      callback: function($$v) {
        _vm.messageVisible = $$v
      },
      expression: "messageVisible"
    }
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('p', {
    staticClass: "mc-title"
  }, [_vm._v("消息中心")]), _vm._v(" "), _c('ul', _vm._l((_vm.unreadMessageInfo.data), function(message) {
    return _c('li', [_c('a', {
      staticClass: "message-title",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.handleShowDetail(message)
        }
      }
    }, [_vm._v(_vm._s(message.title.length > 23 ? message.title.slice(0, 22) + '...' :
      message.title))]), _vm._v(" "), _c('img', {
      staticClass: "message-icon",
      attrs: {
        "src": _vm.icon_new,
        "alt": "mew"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(message.publish_time))])])
  })), _vm._v(" "), _c('p', {
    staticClass: "mc-footer",
    on: {
      "click": _vm.handleShowMoreMessages
    }
  }, [_vm._v("查看更多")])])]), _vm._v(" "), _c('img', {
    staticClass: "nav-logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "restaurant"
  }, [_vm._v("\n    " + _vm._s(_vm.userInfo.agencyName) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "account-area"
  }, [_c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:messageBox",
      arg: "messageBox"
    }],
    staticClass: "message",
    on: {
      "click": _vm.handleGoMsgCenter
    }
  }, [_vm._v("\n      消息\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadMessageInfo.totalCount),
      expression: "unreadMessageInfo.totalCount"
    }],
    staticClass: "message-count"
  }, [_vm._v(_vm._s(_vm.unreadMessageInfo.totalCount))])]), _vm._v(" "), _c('li', {
    staticClass: "x-line"
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "username"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n            欢迎你，" + _vm._s(_vm.userInfo.realName) + "\n            "), (_vm.userInfo.weekPassword) ? _c('img', {
    staticClass: "guide-pwd",
    attrs: {
      "src": _vm.guide_pwd_02
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePwd"
    }
  }, [_vm._v("\n              修改密码\n              "), (_vm.userInfo.weekPassword) ? _c('img', {
    staticClass: "guide-pwd",
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": _vm.guide_pwd_01
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("退出系统")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "password-info-dialog",
    attrs: {
      "model": _vm.passwordForm,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [(_vm.userInfo.weekPassword) ? _c('div', {
    staticClass: "guide-tip"
  }, [_c('span', {
    staticClass: "weak-warn"
  }, [_vm._v("* 温馨提示：")]), _vm._v("您的密码强度较弱，存在被盗风险，建议您更改密码以保护账户安全。")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名："
    }
  }, [_c('span', [_vm._v(_vm._s(this.userInfo.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "旧密码：",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "password", $$v)
      },
      expression: "passwordForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码：",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "minlength": 6,
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "newPwd", $$v)
      },
      expression: "passwordForm.newPwd"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("6-16位，由字母、数字、符号至少两种组成，区分大小写")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码：",
      "prop": "confirmPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.confirmPwd),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "confirmPwd", $$v)
      },
      expression: "passwordForm.confirmPwd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleChgPwd
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('message-dialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.handleCloseDialog
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a851d86c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/NavBar/NavBar.vue
// module id = 761
// module chunks = 8